import {
  isCurrentProductLoaded,
  selectCurrentProduct,
  selectProductsState,
} from '../../../shared/store/_features/products/products.selector';
import { ProgressSpinnerService } from '../../../shared/services/progress-spinner.service';
import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { lastValueFrom, takeWhile } from 'rxjs';
import { ApiService, PromptingService } from '../../../shared/services';
import { MediaLibraryFileModel } from '../../../models/sales-funnel';
import { SharedOwnerDashboardService } from 'src/app/shared/layout/owner-dashboard/shared-owner-dashboard.service';

import {
  createNewProductActions,
  updateCurrentProductActions,
} from 'src/app/shared/store/_features/products/products.actions';
import { Store } from '@ngrx/store';

import {
  deleteWebsiteBlogPostActions,
  WebsiteBlogListActions,
} from 'src/app/shared/store/_features/website/blog/website-blog.actions';
import { BlogPostItem } from 'src/app/models/blog.model';
import { selectDeleteBlogPostProcessStatus } from 'src/app/shared/store/_features/website/blog/website-blog.selector';
import { TopLevelNavMenuItem } from 'src/app/shared/models/navigation.model';
import { ProductItem } from '../product/models/product';

@Injectable({
  providedIn: 'root',
})
export class SharedBlogService {
  minimalProductView: boolean = false;
  productPageNavigations: TopLevelNavMenuItem[] = [];

  currentProductId: number = 0;
  currentProduct: ProductItem;
  // productEditPayload: ProductItem;
  // products: ProductItem[] = [];

  productContentTemp: MediaLibraryFileModel[] | number[] = [];
  isCurrentProductLoaded: boolean = false;
  processing: 'loading' | 'done' | 'none' = 'none';

  deleting: boolean = false;

  pageStatus: 'edit' | 'view' | 'offers';

  productNameError = false;

  constructor(
    private api: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private sharedDashboardService: SharedOwnerDashboardService,
    private progressSpinnerService: ProgressSpinnerService,
    private store: Store,
    private prompting: PromptingService,
  ) {
    this.getProductErrorHandler = this.getProductErrorHandler.bind(this);
    this.store.select(selectCurrentProduct).subscribe((currentProduct) => {
      this.currentProduct = currentProduct;
    });

    this.store.select(isCurrentProductLoaded).subscribe((isLoaded) => {
      this.isCurrentProductLoaded = isLoaded;
    });
  }

  generateProductMenuNav(product: ProductItem) {
    switch (product?.type?.name) {
      case 'course':
        this.generateCourseNavigationMenu(product);
        break;

      default:
        this.generateDownloadbaleNavigationMenu(product);
        break;
    }
  }

  navigateToTypeRoute(product: ProductItem) {
    const currentVisitURL = this.router.url;
    if (currentVisitURL.endsWith(`product/${product.id}`)) {
      switch (product?.type?.name) {
        case 'course':
          if (!currentVisitURL.includes('course')) {
            this.router.navigate(
              ['dashboard', 'product', product.id, 'course'],
              { replaceUrl: true },
            );
          }
          break;

        default:
          if (!currentVisitURL.includes('downloadable')) {
            this.router.navigate(
              ['dashboard', 'product', product.id, 'downloadable'],
              { replaceUrl: true },
            );
          }
          break;
      }
    }
  }

  generateCourseNavigationMenu(product: ProductItem) {
    let OfferCount = !!product?.offers?.length ? product.offers.length : '0';
    const isMultipleOffers = product?.offers?.length > 1;

    this.productPageNavigations = [
      {
        label: 'Edit Details',
        url: `/dashboard/product/${product.id}/course/edit`,
      },
      {
        label: 'Curriculum Builder',
        url: `/dashboard/product/${product.id}/course/builder`,
        // subMenu: [
        //   {label: 'Outline', url: `/dashboard/product/${product.id}/course/builder/outline`},
        //   {label: 'Content', url: `/dashboard/product/${product.id}/course/builder/content`},
        // ]
      },
      {
        label: 'Funnel & Go Live',
        url: `/dashboard/product/${product.id}/course/funnel-and-go-live`,
        subMenu: [
          {
            label: 'Sales Page',
            url: `/dashboard/product/${product.id}/course/funnel-and-go-live/sales-page`,
          },
          {
            label: 'Pricing',
            url: `/dashboard/product/${product.id}/course/funnel-and-go-live/offers`,
          },
          {
            label: 'Thank You Page',
            url: `/dashboard/product/${product.id}/course/funnel-and-go-live/thank-you-page`,
          },
          {
            label: 'Go Live',
            url: `/dashboard/product/${product.id}/course/funnel-and-go-live/go-live`,
          },
        ],
      },
      // {
      //   label: isMultipleOffers ? `Offers (${OfferCount})` : 'Pricing & Offers',
      //   url: `/dashboard/product/${product.id}/offers`,
      // },
      // {
      //   label: 'Students',
      //   url: `/dashboard/product/${product.id}/course/students`,
      // },
      {
        label: 'Students & Reports',
        url: `/dashboard/product/${product.id}/course/reports`,
      },
      {
        label: 'Comments',
        url: `/dashboard/product/${product.id}/course/comments`,
      },
      // {
      //   label: 'Activity',
      //   url: `/dashboard/product/${product.id}/course/activity`,
      // },
    ];
  }

  generateDownloadbaleNavigationMenu(product: ProductItem) {
    let OfferCount = !!product?.offers?.length ? product.offers.length : '0';
    const isMultipleOffers = product?.offers?.length > 1;

    this.productPageNavigations = [
      {
        label: 'Content',
        url: `/dashboard/product/${product.id}/downloadable/content`,
      },
      { label: 'Edit Details', url: `/dashboard/product/${product.id}/edit` },
      {
        label: isMultipleOffers ? `Offers (${OfferCount})` : 'Pricing & Offers',
        url: `/dashboard/product/${product.id}/offers`,
      },
    ];
  }

  // async getProductById(id: number) {

  //   this.store.dispatch(CurrentProductActions.load({productId: id}))

  //   // this.loaded.item = false;
  //   // const product$ = this.api.getProductById(id, this.getProductErrorHandler);
  //   // this.product = await lastValueFrom(product$);
  //   // this.loaded.item = true;
  // }

  // async getCourseById(id: number) {
  //   this.loaded.item = false;
  //   const product$ = this.api.getCourseById(id, this.getProductErrorHandler);
  //   this.product = await lastValueFrom(product$);
  //   this.productEditPayload = JSON.parse(JSON.stringify(this.product));
  //   this.loaded.item = true;
  // }

  getProductErrorHandler(error: any) {
    this.goToProducts();
  }

  onChooseCreate() {
    this.router.navigate(['dashboard', 'blog', 'create']);
  }

  startProcessing() {
    this.processing = 'loading';
  }

  endProcessing() {
    this.processing = 'done';
    setTimeout(() => {
      this.processing = 'none';
    }, 1000);
  }

  enableNavigate() {
    this.sharedDashboardService.enableNavigate();
  }

  disableNavigate() {
    this.sharedDashboardService.disableNavigate();
  }

  async updateProduct(
    productId: number,
    payload: Partial<ProductItem>,
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      this.store.dispatch(
        updateCurrentProductActions.update({ productId, changes: payload }),
      );

      this.store
        .select(selectProductsState)
        .pipe(
          takeWhile(
            (state) =>
              state?.currentProduct.updating !== 'done' &&
              state?.currentProduct.updating !== 'error',
            true,
          ),
        )
        .subscribe((state) => {
          console.log(
            'Current Product Update Status is: ',
            state?.currentProduct.updating,
          );
          switch (state?.currentProduct.updating) {
            case 'done':
              this.onProductUpdate(state.currentProduct);
              resolve(state.currentProduct);
              break;
            case 'error':
              this.onProductUpdateError(state.currentProduct.errorMessage);
              reject(state.currentProduct.errorMessage);
              break;
            default:
              break;
          }
        });
    });
    // this.startProcessing();
    // const UpdateRequest$ = this.api.updateProduct(
    //   this.currentProductId,
    //   payload
    // );
    // const UpdateRequest: ProductEditResponse = await lastValueFrom(
    //   UpdateRequest$
    // );

    // this.currentProduct = UpdateRequest.product;
    // this.toastr.success('Updated Successfully', 'Done!', {
    //   closeButton: false,
    //   positionClass: 'toast-bottom-right',
    // });
    // this.enableNavigate();
    // this.endProcessing();
    // return false;
  }

  onProductUpdate = (product: ProductItem) => {
    this.toastr.success('Updated Successfully', 'Done!');
    this.sharedDashboardService.enableNavigate();
  };

  onProductUpdateError = (errorMessage: string) => {
    this.toastr.error(errorMessage);
    this.sharedDashboardService.enableNavigate();
  };

  goToProducts() {
    this.router.navigate(['dashboard', 'product']);
  }

  goToView() {
    this.router.navigate([
      'dashboard',
      'product',
      this.currentProductId,
      'view',
    ]);
  }

  goToEdit() {
    this.router.navigate([
      'dashboard',
      'product',
      this.currentProductId,
      'edit',
    ]);
  }

  goToProductOffers() {
    this.router.navigate([
      'dashboard',
      'product',
      this.currentProductId,
      'offers',
    ]);
  }

  async getBlogPosts() {
    this.store.dispatch(WebsiteBlogListActions.load());
  }

  async cloneProductAlert(product: ProductItem) {
    this.prompting
      .fire(
        {
          allowOutsideClick: false,
          input: 'checkbox',
          icon: 'info',
          inputPlaceholder:
            'I confirm that I want to <strong class="text-info">Clone</strong> this product.',
          title:
            'Are you sure you want to clone <strong>' +
            product.name +
            '</strong> product?',
          html: 'This <strong>Product</strong> will be duplicated',
          confirmButtonText: 'Clone',
          showLoaderOnConfirm: true,
          preConfirm: async () => {
            const cloneRequest$ = this.api.cloneProduct(product.id);
            const cloneRequest = await lastValueFrom(cloneRequest$);
            this.toastr.success('Done!', 'Product Cloned Successfully', {
              closeButton: false,
              positionClass: 'toast-bottom-right',
            });
            return cloneRequest;
          },
          showCancelButton: true,
          reverseButtons: true,
          inputValidator: (result) => {
            return !result && 'You need to agree';
          },
          didOpen: () => {
            const deleteCheck = this.prompting.getInput();
            const confirmCheck = this.prompting.getConfirmButton();
            const cancelButton = this.prompting.getCancelButton();

            if (confirmCheck && deleteCheck) {
              confirmCheck.setAttribute('disabled', 'disabled');
              confirmCheck.setAttribute('style', 'pointer-events: none;');
              deleteCheck.addEventListener('change', function () {
                if ((this as HTMLInputElement).checked) {
                  confirmCheck.removeAttribute('disabled');
                  confirmCheck.removeAttribute('style');
                } else {
                  confirmCheck.setAttribute('disabled', 'disabled');
                  confirmCheck.setAttribute('style', 'pointer-events: none;');
                }
              });
              confirmCheck.addEventListener('click', () => {
                confirmCheck.innerHTML = 'Cloning, Please Wait...';
                if (cancelButton)
                  cancelButton.setAttribute('disabled', 'disabled');
                confirmCheck.setAttribute('disabled', 'disabled');
                deleteCheck.setAttribute('disabled', 'disabled');
              });
            }
          },
        },
        'lg',
      )
      .then((res) => {
        if (!!res.value) {
          this.store.dispatch(createNewProductActions.create(res.value));
        } else {
          return false;
        }
      });
  }

  async deleteProductAlert(article: BlogPostItem) {
    this.prompting.confirm(
      {
        allowOutsideClick: false,
        icon: 'error',
        title: 'Are you sure want to delete?',
        html: `Are you sure want to delete <strong>${article.title}</strong>?`,
        confirmButtonText: 'Delete',
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          await this.deleteWebsiteBlogPostActions(article);

          return true;
          // TODO: Delete Request
        },
        isDanger: true,
      },
      'lg',
    );
  }

  async deleteWebsiteBlogPostActions(article: BlogPostItem) {
    return new Promise<any>((resolve, reject) => {
      this.store.dispatch(
        deleteWebsiteBlogPostActions.delete({ postId: article.id }),
      );

      this.store
        .select(selectDeleteBlogPostProcessStatus)
        .pipe(takeWhile((process) => process.status === 'deleting', true))
        .subscribe((process) => {
          if (process.status === 'done') {
            this.toastr.success('Article Deleted Successfully');
            resolve(process);
          } else if (!!process.error) {
            this.toastr.error(process?.error?.error);
            reject(process.error);
          }
        });
    });
  }
}
